import React from "react"
import { Link } from "gatsby"
import Layout from "../../components/root/Layout"
import Seo from "../../components/root/Seo"
import InProgress from "../../components/utils/InProgress"
export default function About() {
  return (
    <Layout>
        <Seo title="Success Stories" />
        <InProgress pageName="Success Stories"/>
    </Layout>
  )
}
